import React, { Component } from "react";
import Form, { Item } from "devextreme-react/form";

export default class Link extends Component {
  constructor(props) {
    super(props);
    this.state = {
      linkForm: {
        text: null,
        url: null,
        newTab: false,
      },
    };
    this.attachLink = (e) => {
      let cursorPosition = this.props.editorInstance.getLength() - 1;

      this.props.editorInstance.insertEmbed(cursorPosition, "link", {
        href: this.state.linkForm.url,
        text: this.state.linkForm.text,
        target: this.state.linkForm.newTab,
      });
      this.setState({
        linkForm: { text: null, url: null, newTab: null },
      });
      this.props.editorInstance.focus();
      this.props.hidePopup();
    };
  }
  render() {
    return (
      <div>
        <div>
          <Form formData={this.state.linkForm}>
            <Item
              dataField="text"
              editorType="dxTextBox"
              editorOptions={{
                stylingMode: "underlined",
                placeholder: "Visible Text",
                width: "300px",
              }}
            />
            <Item
              dataField="url"
              editorType="dxTextBox"
              editorOptions={{
                stylingMode: "underlined",
                placeholder: "Actual URL",
                width: "300px",
              }}
            />
            <Item
              dataField="height"
              editorType="dxCheckBox"
              label={{ text: "Open in new tab" }}
              editorOptions={{
                stylingMode: "underlined",
              }}
            />
            <Item
              editorType="dxButton"
              editorOptions={{
                text: "Add",
                onClick: this.attachLink,
              }}
            />
          </Form>
        </div>
      </div>
    );
  }
}
